module.exports = __webpack_public_path__ + "img/so-so.cc59d22f.svg";